<router-outlet></router-outlet>

<cookie-consent-banner></cookie-consent-banner>
